import { render, staticRenderFns } from "./ContactInformationEdit.vue?vue&type=template&id=f261a886"
import script from "./ContactInformationEdit.vue?vue&type=script&lang=js"
export * from "./ContactInformationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports